import { render, staticRenderFns } from "./suratKonfirmasi.vue?vue&type=template&id=ffceb01c"
import script from "./suratKonfirmasi.vue?vue&type=script&lang=js"
export * from "./suratKonfirmasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports